/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DevRobotIcon20Solid = forwardRef('DevRobotIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11 2.906a1.625 1.625 0 1 0-2 0V4H7a4 4 0 0 0-4 4v1H1a1 1 0 1 0 0 2h2v3a4 4 0 0 0 4 4h6a4 4 0 0 0 4-4v-3h2a1 1 0 1 0 0-2h-2V8a4 4 0 0 0-4-4h-2V2.906ZM14.25 10a1.375 1.375 0 1 1-2.75 0 1.375 1.375 0 0 1 2.75 0Zm-7.125 1.375a1.375 1.375 0 1 0 0-2.75 1.375 1.375 0 0 0 0 2.75Z" })));
});
